// Thư mục: src/services/dmChecklistItemService.js
import api from "@/api";

/**
 * API service cho "Ngân hàng hạng mục"
 */
export const DmChecklistItemApi = {
  // Lấy danh sách phân trang
  list({ page = 0, size = 10, sort = "id,desc" } = {}) {
    return api
      .get("/api/dm-checklist-items", { params: { page, size, sort } })
      .then((res) => res.data);
  },

  // Lấy chi tiết 1 hạng mục
  get(id) {
    return api.get(`/api/dm-checklist-items/${id}`).then((res) => res.data);
  },

  // Tạo hạng mục mới
  create(payload) {
    return api.post("/api/dm-checklist-items", payload).then((res) => res.data);
  },

  // Cập nhật hạng mục
  update(id, payload) {
    return api
      .put(`/api/dm-checklist-items/${id}`, payload)
      .then((res) => res.data);
  },

  // Xóa hạng mục
  remove(id) {
    return api.delete(`/api/dm-checklist-items/${id}`).then((res) => res.data);
  },

  /**
   * Lấy TẤT CẢ hạng mục đang active (không phân trang)
   * Gọi API mới mà chúng ta vừa thêm ở Backend
   */
  listAllActive() {
    return api
      .get("/api/dm-checklist-items/all-active")
      .then((res) => res.data);
  },
};
